jQuery(($) => {
    //a lot of these variable definitions are copied from the site specific builds which need to be generalized to all sites
    var MOBILE_WIDTH = 991;
    var $nav = $('.navbar .navbar-nav'),
        $navItems = $nav.find('> li'),
        $navBar = $('.navbar-header'),
        $body = $('body').removeClass('no-js'),
        $navMenus = $navItems.find('.sub-menu');

    /**
     * Checks if the current view is on mobile or not
     * @returns {boolean} true if this is mobile, false otherwise
     */
    function isMobile() {
        return window.innerWidth <= MOBILE_WIDTH;
    }

    /**
     * Touch to open a menu item.
     * @param {HTMLElement} element The touch event
     * @return {void}
     */
    function touchOpen(element) {
        var $item = element.closest('.menu-item');

        if (!$navMenus.is(':visible')) {
            // Open the menu.
            open($item.addClass('highlighted'));
        } else if (!$item.find('.sub-menu').is(':visible')) {
            // Switch to a different menu.
            $navMenus.find(':visible').closest('.menu-item').removeClass('highlighted');
            open($item.addClass('highlighted'));
        }
    }

    /**
     * Touch to close a menu item.
     * @param {HTMLElement} element The touch event
     * @return {void}
     */
    function touchClose(element) {
        if (($(element).parents('.navbar-nav').length === 0) && $navMenus.is(':visible')) {
            // Close the menu.
            close($navMenus.filter(':visible').closest('.menu-item').removeClass('highlighted'));
            $body.off('touchend click', touchClose);
        }
    }

    /**
     * Open a sub-menu.
     * @param {jQuery} $item The navItem to open
     * @return {void}
     */
    function open($item) {
        var $subMenu = $item.find('.sub-menu');
        var $arrow = $item.find('.menu-arrow');
        var $anchor = $item.find('a');
        var leftPadding = parseInt($anchor.css('padding-left'), 10);

        if ($nav.height() > 80 && !isMobile()) {
            $subMenu.css('top', $nav.height() - parseInt($item.css('padding-top'), 10));
        } else {
            $subMenu.css('top', '');
        }

        $arrow.css('margin-left', $anchor.width() / 2 - $arrow.data('width') / 2 + leftPadding);

        if ($navMenus.is(':visible')) {
            var $otherMenu = $('.sub-menu:visible');

            if (!$otherMenu.is($subMenu)) {
                var otherHeight = $otherMenu.outerHeight();
                var subHeight = $subMenu.outerHeight();

                if (isMobile()) {
                    // Open/close the menus.
                    $otherMenu.slideUp('fast', function () {
                        $('#nav-menu').animate({
                            scrollTop: $item.position().top - $navBar.height()
                        });
                        $subMenu.slideDown();
                    });
                } else {
                    // Close the other menu.
                    $otherMenu.hide();

                    // Open the new one, transitioning to the correct height.
                    $subMenu.css({
                        height: otherHeight,
                        display: 'block'
                    }).animate({height: subHeight}, function () {
                        $subMenu.height('auto');
                    });
                    $('.menu-arrow').hide();
                    $arrow.show();
                }
            }
        } else {
            $subMenu.slideDown();
            if (isMobile()) {
                $('#nav-menu').animate({
                    scrollTop: $item.position().top - $navBar.height()
                });
            } else {
                $arrow.fadeIn({queue: false, duration: 'fast'});
            }

            $body.on('touchend click', touchClose);
        }
    }

    /**
     * Close a sub-menu.
     * @param {jQuery} $item The navItem to close
     * @return {void}
     */
    function close($item) {
        $item.find('.sub-menu').slideUp();

        if (!isMobile()) {
            $item.find('.menu-arrow').fadeOut({queue: false, duration: 'fast'});
        }
    }

    /**
     * A method which is the eventlistener for each of the nav elements, to handle when the user is using keyboard navigation on the header
     * @param {HTMLElement} $element the element which contains the sub-menu
     * @param {InputEvent} event the element which focused during the keypress
     * @return {void}
     */
    function handleNavKeyPress($element, event) {
        //check if the event target is not hte current $navItem
        if (event.target !== $element) {
            console.log('allowing default behaviour');
            return;
        }
        if (event.key === 'Enter' || event.keyCode === 13) {
            event.preventDefault();
            let $subMenu = $($element).find('.sub-menu');

            if (!$subMenu.length) {
                console.log('Sub-menu not found!');
                return;
            }
            //check if this element has style="display: block;" or not--- this will be used to determine if we should open or close this element on enter press
            if (!($subMenu.attr('style') && $subMenu.attr('style').includes("display: block;"))) {
                if (!isMobile()) {
                    open($($element));
                } else {
                    touchOpen($($element));
                }
            } else {
                if (!isMobile()) {
                    close($($element));
                } else {
                    touchClose($($element));
                }
            }

        }
    }
    for (let ind=0; ind < $navItems.length; ind++) {
        $navItems[ind].addEventListener('keydown', function(event) {
            handleNavKeyPress(this, event);
        });
        $($navItems[ind]).attr('tabindex', '0');
        // Add the class on focus
        $navItems[ind].addEventListener('focus', function() {
            this.classList.add('highlighted');
        });

        // Remove the class on blur
        $navItems[ind].addEventListener('blur', function() {
            this.classList.remove('highlighted');
        });
    }
});
